import { render } from "./pagckageStarCategory.vue?vue&type=template&id=1c4418d2&scoped=true"
import script from "./pagckageStarCategory.vue?vue&type=script&lang=js"
export * from "./pagckageStarCategory.vue?vue&type=script&lang=js"

import "./pagckageStarCategory.vue?vue&type=style&index=0&id=1c4418d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4418d2"]])

export default __exports__